export default __webpack_public_path__ + "static/brian-bitmoji-b09563d1796e6ea0a0b36025112d09d6.png";